<template>
  <v-container id="eixo-list">
    <v-row
      v-if="
        isFullAdmin ||
        (config.adicionarCategoriaTerritorio &&
          groupsConfig.adicionarCategoriaTerritorio)
      "
    >
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="$router.push(`/gestao-territorios/${tabType}/0/edit`)"
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhuma Categoria </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="
                isFullAdmin ||
                (config.editarCategoriaTerritorio &&
                  groupsConfig.editarCategoriaTerritorio)
              "
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/gestao-territorios/${tabType}/${item.territorioCategoriaId}/edit`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// import modalDelete from "./modalDelete";
import { territoriosCategoriaAPI } from "@/modules/gestao-territorios/API/territoriosCategoriaAPI";
import { territorioFaseAPI } from "@/modules/gestao-territorios/API/territorioFaseAPI";

export default {
  components: {
    // modalDelete,
  },
  computed: {
    ...mapGetters(["config", "groupsConfig", "isFullAdmin"]),
  },
  data() {
    return {
      headers: [
        { text: "Fase", value: "fase" },

        { text: "Categoria", value: "nomeCategoria" },
        { text: "Ações", value: "actions" },
      ],
      values: [],
      tabType: this.$route.params.tab,
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      territoriosCategoriaAPI
        .list()
        .then(({ data }) => {
          territorioFaseAPI
            .list()
            .then((resp) => {
              this.values = data.map((item) => {
                const fase = resp.data.find(
                  (fase) => fase.territorioFaseId === item.territorioFaseId
                );
                return {
                  ...item,
                  nomeCategoria: item.nomeCategoria,
                  fase: fase ? fase.nome : "Sem Fase",
                };
              });
              this.setLoading(false);
            })
            .catch((resp) => {
              this.$notification.error("Erro ao obter fases");
            });

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao listar Categoria");
          console.log("Erro no List Territorios Categorias ", err);
        });
    },
  },

  mounted() {
    this.load();
  },
};
</script>
<style scoped lang="scss">
.col-values {
  display: flex;
  justify-content: flex-end;
}

.share-link {
  background: #5c8bb9 !important;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  width: 80%;
  .v-icon {
    color: #ffffff !important;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
      rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
      rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
}
</style>
